module.exports = __webpack_public_path__ + "img/high-wheeler.ebbc4e74.webp";